
import React, { Fragment } from 'react';

const datas = {
    dayOfTheMonth: {
        1: '1st', 2: '2nd', 3: '3rd', 4: '4th', 5: '5th', 6: '6th', 7: '7th', 8: '8th', 9: '9th', 10: "10th", 11: '11th', 12: '12th'
    },
};

export const Yearly = (props) => {
    const { FormControl, clsx, classes, FormGroup, changeEveryHandler, Checkbox, FormControlLabel, every, view } = props;

    return (
        <>
            <FormControl
                tabIndex={-1}
                className={clsx(classes.margin20t, classes.customRadioButton)}
                variant={'standard'}
                fullWidth>
                <div className={classes.frequencyEveryPos}>
                    <div className={clsx(classes.frequencyEveryText, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Every</div>
                    <FormGroup aria-label="position" row>
                        {
                            Object?.entries(datas['dayOfTheMonth'])?.map(([key, value]) => (
                                <FormControlLabel
                                    value={key}
                                    key={key}
                                    disabled={view}
                                    name={`every_${key}`}
                                    control={<Checkbox size={'small'} checked={every[`every_${key}`]}
                                        onChange={(e) => changeEveryHandler(e)}
                                    />}
                                    label={value}
                                    labelPlacement="end"
                                />
                            ))
                        }
                    </FormGroup>
                </div>
            </FormControl>
        </>
    )
}

export const YearlyListView = (props) => {
    return (
        <>
            {
                Object?.entries(datas['dayOfTheMonth'])?.map(([key, value]) => (
                    <Fragment key={key}> {props?.data[`every_${key}`] ?
                        <span className={props.classes.everyDis}>{value}</span> : ''}</Fragment>
                ))
            }
        </>
    )
}